import React from 'react';
import styled, { css } from 'styled-components';
import { colors, fontWeight } from '@grnhse/seedling/lib/azalea/constants';

const Container = styled.ul`
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 280px;
  background: ${colors.lightestGrey};
  border: 1px solid ${colors.lightGrey};
  padding: 15px;
`;

const Token = styled.li`
  font-size: 12px;
  list-style-type: none;
  color: ${colors.darkerGrey};
  letter-spacing: 0.5px;
  font-weight: ${fontWeight.normal};
  line-height: 24px;
  ${(props) =>
    props.fontSize &&
    css`
      & > p {
        font-size: ${props.fontSize}px !important;
      }
    `}
`;

const AvailableTokens = ({ tokens, fontSize }) => {
  return (
    <Container>
      {tokens.map((token) => (
        <Token fontSize={fontSize} key={token}>
          <p>{token}</p>
        </Token>
      ))}
    </Container>
  );
};

export default AvailableTokens;
